import { create } from 'zustand'
import { getCachedUserToken } from '../services/userToken'

const useAuthStore = create((set) => ({
  isLoggedIn: false,
  setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),

  // User session token from URL/session context when available.
  accessToken: null,
  setAccessToken: (accessToken) => set({ accessToken }),

  fileBuffer: null,
  setFileBuffer: (fileBuffer) => set({ fileBuffer }),

  fileBlob: null,
  setFileBlob: (fileBlob) => set({ fileBlob }),

  loading: false,
  setLoading: (loading) => set({ loading }),

  // Fatal / blocking errors (displayed in-place; do not navigate)
  error: null,
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // User token getter - checks store, sessionStorage, then falls back to cached service value
  getUserToken: () => {
    const state = useAuthStore.getState();
    if (state.accessToken) return state.accessToken;
    return getCachedUserToken({ includeUrl: true });
  },
}))

export default useAuthStore;
